import { cn } from "../../../lib/utils";

export const CustomCard = ({ name, description, Icon, className, image }) => {
  return (
    <div
      className={cn(
        "relative p-8 rounded-2xl border backdrop-blur-sm transition-all duration-300 bg-background/50 dark:bg-background/40 border-border/50 dark:border-border/80 hover:bg-background/60 dark:hover:bg-background/60flex flex-col justify-center items-center text-center",
        className
      )}
    >
      <div className="mb-6 relative flex items-center justify-center">
        <div
          className="w-16 h-16 rounded-full flex items-center justify-center relative 
                    bg-blue-600/20 dark:bg-blue-600/20 
                    group-hover:scale-110 transition-transform duration-300"
        >
          <div
            className="absolute inset-0 rounded-full bg-blue-600/10 dark:bg-blue-600/30 blur-xl 
                      group-hover:bg-blue-600/30 transition-all duration-300"
          />
          <div
            className="absolute inset-0 rounded-full bg-gradient-to-br from-blue-600/30 to-blue-600/0 
                      opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          />
          {image ? (
            <img
              src={image}
              alt={name}
              className="w-full h-full object-cover rounded-full"
            />
          ) : (
            Icon &&
            image === null && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-6 h-6"
              >
                <path d="M2 17a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V8.32a5 5 0 0 0-2.64-4.4L12 0 4.64 3.92A5 5 0 0 0 2 8.32Z" />
                <path d="m6 12 6-3 6 3" />
                <path d="M12 9v8" />
              </svg>
            )
          )}
          {Icon && <Icon className="w-8 h-8 text-primary relative z-10" />}
        </div>
      </div>
      <h3
        className="text-xl font-semibold mb-3 text-foreground dark:text-foreground 
                 group-hover:text-primary transition-colors duration-300"
      >
        {name}
      </h3>
      <p
        className="text-muted-foreground dark:text-muted-foreground 
                group-hover:text-primary dark:group-hover:text-primary transition-colors duration-300"
      >
        {description}
      </p>
    </div>
  );
};
